module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.11444/img/diamond-tier-icon.svg"